import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Goal} from '../../../../../models/goal';
import {Paginator} from '../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {GoalService} from '../../../../../services/goal/goal.service';
import {ConfirmDirective} from '../../../../../directives/confirm/confirm.directive';

import {PaginatorComponent} from '../../../../layout/paginator/paginator.component';
import {TableSorterHeaderDirective} from '../../../../../directives/table-sorter/table-sorter-header.directive';
import {RouterLink} from '@angular/router';
import {TableSorterDirective} from '../../../../../directives/table-sorter/table-sorter.directive';
import {IsGranted} from '../../../../../decorator/is-granted';
import {IsGrantedDirective} from '../../../../../directives/is-granted/is-granted.directive';
import {MetaTitle} from '../../../../../decorator/meta-title';

@Component({
  selector: 'app-goal-list',
  imports: [
    ConfirmDirective,
    PaginatorComponent,
    TableSorterHeaderDirective,
    RouterLink,
    TableSorterDirective,
    IsGrantedDirective
],
  templateUrl: './goal-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './goal-list.component.scss'
})
@IsGranted(['GOAL_VIEW'])
@MetaTitle('Goals')
export class GoalListComponent implements OnInit {
  goals: Goal[] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('id', 'asc');

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private goalService: GoalService
  ) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    this.goalService.findAll({}, this.paginator, this.tableSorter).subscribe((goals) => {
      this.goals = goals;

      this.loader.stopLoading();
    })
  }

  delete(goal: Goal): void {
    if (goal.id) {
      this.loader.startLoading();
      this.goalService.delete(goal.id).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Goal has been deleted');
        this.refresh();
      });
    }
  }
}
